<script>
export default {
  name: 'DatePicker',
  props: {
    label: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    allowedDates: {
      type: Function,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <v-content class="ma-0 pa-0">
    <v-menu
      :close-on-content-click="true"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="date"
          v-on="on"
          :label="label"
          :disabled="disabled"
          prepend-icon="event"
          readonly
        />
      </template>
      <v-date-picker
        @change="$emit('updateFilter', $event)"
        :value="date"
        :allowedDates="allowedDates"
        :show-current="true"
      />
    </v-menu>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/components/payments/PaymentsDatePicker.vue